"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.REMOTE_LOGGING_REL = exports.REMOTE_LOGGING_URL = void 0;
exports.REMOTE_LOGGING_URL = '/rest/remote-logging/logs';
exports.REMOTE_LOGGING_REL = 'rl:swallow';
